import { render, staticRenderFns } from "./closure_review.vue?vue&type=template&id=617bf5d9&scoped=true&"
import script from "./closure_review.vue?vue&type=script&lang=js&"
export * from "./closure_review.vue?vue&type=script&lang=js&"
import style0 from "./closure_review.vue?vue&type=style&index=0&id=617bf5d9&lang=less&scoped=true&"
import style1 from "./closure_review.vue?vue&type=style&index=1&id=617bf5d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617bf5d9",
  null
  
)

export default component.exports